'use client';
import { useEffect } from 'react';
import { useRenderContext } from '../contexts/RenderProvider.mjs';
import { isBrowser, VERSION } from '../utils/env.mjs';

// https://developer.mozilla.org/ko/docs/Web/API/Navigator/sendBeacon
function canLogging() {
  return isBrowser && 'sendBeacon' in window.navigator;
}
const TRACE_DEV_API = 'https://tr-qa.pay.naver.com';
const TRACE_REAL_API = 'https://tr.pay.naver.com';
function sendLogging(params, isDevelopment) {
  if (canLogging()) {
    navigator.sendBeacon(`${isDevelopment ? TRACE_DEV_API : TRACE_REAL_API}/trace/component`, new Blob([JSON.stringify({
      ...params,
      service: 'defign',
      version: VERSION,
      targetMethod: 'POST'
    })], {
      type: 'application/json'
    }));
  }
}
function logging(url, components, isDevelopment) {
  try {
    sendLogging({
      action: 'view',
      targetUrl: url,
      customMap: components
    }, isDevelopment);
  } catch {}
}
function useApplyLogging(target) {
  const {
    register,
    isTargetUser
  } = useRenderContext();
  useEffect(() => {
    if (isTargetUser && canLogging()) {
      register(target);
    }
  }, [register, target, isTargetUser]);
}

export { canLogging, useApplyLogging as default, logging };
